import { useEffect, useState } from "react";
import FilteredDoctorCard from "./FilteredDoctorCard";
import SortDrawer from "./SortDrawer";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const FilteredDoctorsSection = ({
  doctors,
  totalItems,
  onNumberPass,
  setNumberFromChild,
  numberFromChild,
  filteredDoctors,
}) => {
  const doctorsPerPage = 20;
  const totalPages = Math.ceil(totalItems / doctorsPerPage);

  // State to track current screen size
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768); // Adjust breakpoint as needed

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768); // Adjust breakpoint as needed
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handlePageChange = (page) => {
    // Ensure the page number is within valid bounds
    const newPage = Math.max(1, Math.min(page, totalPages));
    if (newPage !== numberFromChild) {
      setNumberFromChild(newPage);
      onNumberPass(newPage);
      console.log("page is:", newPage);
    }
  };

  const renderPageButtons = () => {
    const pageButtons = [];
    // Determine max visible buttons based on screen size
    const maxVisibleButtons = isMobile ? 2 : 4; // 2 for mobile, 4 for larger screens

    // Previous button
    pageButtons.push(
      <button
        key="prev"
        className="px-3 py-1 border-2 rounded-[10px] disabled:opacity-50 flex items-center justify-center"
        onClick={() => handlePageChange(numberFromChild - 1)}
        disabled={numberFromChild === 1}
      >
        <FaChevronRight />{" "}
        {/* Changed to FaChevronRight for consistency with Persian text direction */}
      </button>,
    );

    //buttons
    let startPage, endPage;
    if (totalPages <= maxVisibleButtons) {
      startPage = 1;
      endPage = totalPages;
    } else {
      // Logic to determine start and end pages based on current page and maxVisibleButtons
      if (numberFromChild <= Math.floor(maxVisibleButtons / 2)) {
        startPage = 1;
        endPage = maxVisibleButtons; // Show first few pages
      } else if (
        numberFromChild >
        totalPages - Math.floor(maxVisibleButtons / 2)
      ) {
        startPage = totalPages - maxVisibleButtons + 1;
        endPage = totalPages; // Show last few pages
      } else {
        startPage = numberFromChild - Math.floor(maxVisibleButtons / 2);
        endPage = numberFromChild + Math.floor(maxVisibleButtons / 2);
      }
    }

    // Render the first page button if needed and not in the visible range
    if (startPage > 1) {
      pageButtons.push(
        <button
          key={1}
          className={`px-3 py-1 w-10 h-10 rounded-[10px] flex items-center justify-center ${
            numberFromChild === 1 ? "bg-aqua text-white" : "border-2"
          }`}
          onClick={() => handlePageChange(1)}
        >
          1
        </button>,
      );
      // Add ellipsis if there's a gap
      if (startPage > 2) {
        pageButtons.push(
          <button
            key="ellipsis-start"
            className="px-3 py-1 border-2 rounded-[10px] disabled:opacity-50 flex items-center justify-center"
            disabled
          >
            ...
          </button>,
        );
      }
    }

    // Render the page numbers within the calculated range
    for (let i = startPage; i <= endPage; i++) {
      if (i >= 1 && i <= totalPages) {
        pageButtons.push(
          <button
            key={i}
            className={`px-3 py-1 w-10 h-10 rounded-[10px] flex items-center justify-center ${
              numberFromChild === i ? "bg-aqua text-white" : "border-2"
            }`}
            onClick={() => handlePageChange(i)}
          >
            {i}
          </button>,
        );
      }
    }

    // Render the last page button and ellipsis if needed
    if (endPage < totalPages - 1) {
      pageButtons.push(
        <button
          key="ellipsis-end"
          className="px-3 py-1 border-2 rounded-[10px] disabled:opacity-50 flex items-center justify-center"
          disabled
        >
          ...
        </button>,
      );
      pageButtons.push(
        <button
          key={totalPages}
          className={`px-3 py-1 w-10 h-10 rounded-[10px] flex items-center justify-center ${
            numberFromChild === totalPages ? "bg-aqua text-white" : " border-2"
          }`}
          onClick={() => handlePageChange(totalPages)}
        >
          {totalPages}
        </button>,
      );
    } else if (endPage === totalPages - 1 && totalPages > maxVisibleButtons) {
      // Special case for showing last page if it's just before the ellipsis
      if (numberFromChild !== totalPages) {
        pageButtons.push(
          <button
            key={totalPages}
            className={`px-3 py-1 w-10 h-10 rounded-[10px] flex items-center justify-center ${
              numberFromChild === totalPages
                ? "bg-aqua text-white"
                : " border-2"
            }`}
            onClick={() => handlePageChange(totalPages)}
          >
            {totalPages}
          </button>,
        );
      }
    }

    // Next button
    pageButtons.push(
      <button
        key="next"
        className="px-3 py-1 border-2 rounded-[10px] disabled:opacity-50 flex items-center justify-center"
        onClick={() => handlePageChange(numberFromChild + 1)}
        disabled={numberFromChild === totalPages}
      >
        <FaChevronLeft />{" "}
        {/* Changed to FaChevronLeft for consistency with Persian text direction */}
      </button>,
    );

    return pageButtons;
  };

  useEffect(() => {
    // Optionally re-run handlePageChange if numberFromChild changes on mount or resize
    // handlePageChange(numberFromChild);
  }, [numberFromChild, isMobile]); // Depend on numberFromChild and isMobile

  return (
    <div className="flex flex-col overflow-x-hidden items-center">
      {/* کارت پزشکان */}
      <div className="grid grid-cols-1 gap-3 md:gap-5 w-full">
        {filteredDoctors.map((doctor) => (
          <FilteredDoctorCard
            key={doctor.id}
            id={doctor.id}
            image={`https://bit.medizen.ir/i/${doctor.thumb}`}
            name={doctor.name}
            score={doctor.score}
            title={doctor.title}
            consultations={doctor.count}
            activityStatus={doctor.activity_status}
            serviceList={doctor.service_list}
            address={doctor.address}
          />
        ))}
      </div>

      {totalPages >= 1 && (
        <div className="flex justify-center mt-5 gap-2">
          {renderPageButtons()}
        </div>
      )}
    </div>
  );
};

export default FilteredDoctorsSection;
